export default __webpack_public_path__ + "static/media/blox-empty-state.39881185.svg";